<div class="bn-alert-notice" *ngIf="!hideAlert">
    <div class="bn-icon">
        <img src="./assets/img/images/icon-check-success.svg" alt="success icon" />
    </div>
    <div class="bn-content">
        <div class="bn-content-text">
            <div class="bn-content-text-sub">
                <div class="bn-content-text-title">{{title}}</div>
                <div class="bn-content-close">
                    <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                        (click)="onClose()" />
                </div>
            </div>
            <div class="lh-18" [ngClass]="{'lh-20':isAcmic}">{{message}}</div>
        </div>
    </div>
</div>